import React, { useContext } from "react";
import GroupContext from "../../context/group";

const FormRadio = ({ id, options, field, isRequired, ...other }) => {
  const { formData, onChange, formErrors } = useContext(GroupContext);
  return (
    <div className="form__radio">
      {options.map((option) => (
        <React.Fragment key={option.value}>
          <input
            id={`${id}_${option.value}`}
            type="radio"
            value={option.value}
            name={field}
            checked={formData[field] === option.value}
            onChange={onChange}
            data-required={isRequired}
            {...other}
          />
          <label className="form__radio-label" htmlFor={`${id}_${option.value}`}>
            {option.label}
          </label>
        </React.Fragment>
      ))}
      {formErrors[field] && (
        <span className="form__error-message d-inline">{formErrors[field]}</span>
      )}
    </div>
  );
};

export default FormRadio;
